import { render, staticRenderFns } from "./stadium_rank.vue?vue&type=template&id=0d04b316&"
import script from "./stadium_rank.vue?vue&type=script&lang=ts&"
export * from "./stadium_rank.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports